import type { DynamicPropertyToGroupDto } from "../../types/DynamicPropertyToGroupDto";
import type { DynamicPropertyToGroupEntity } from "../../types/DynamicPropertyToGroupEntity";

export const DynamicPropertyToGroupDtoToEntity = ({
    key,
    id,
    ...rest
}: Readonly<DynamicPropertyToGroupDto>): DynamicPropertyToGroupEntity => {
    return { id, ...rest, keyProp: key, dynamicPropertyId: id };
};
